<template>
  <div class="subject-select" v-if="isPrepped">
    <div class="row subject-select-header">
      <div class="col-2">
        <div class="edit-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" stroke="#3c763d" stroke-width="2px"/>
          </svg>
        </div>
      </div>
      <div class="col-8 text-center">
      Subject Selection
      </div>
      <div class="col-2">
        <div class="edit-icon text-end">
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" stroke="#3c763d" stroke-width="2px"/>
          </svg>
        </div>
      </div>
    </div>
    <div class="row primary-area-select">
      <div class="col-3 col-lg-2 question-label">Select A Primary Area Of Study:</div>
      <div class="col-7 col-lg-8 question">
        <div class="row row-cols-3">
          <div v-for="val in values" class="col button-holder" :key="val.id">
            <button type="button" class="btn" :class="{ 'btn-success': val.id === primarySubject, 'btn-outline-dark': val.id !== primarySubject}" @click="setPrimarySubject(val.id)">{{val.name}}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row secondary-area-select" v-show="primarySubject !== null">
      <div class="col-3 col-lg-2 question-label">Select Up To 2 Additional Areas Of Study:</div>
      <div class="col-7 col-lg-8 question">
        <div class="row row-cols-3">
          <div v-for="val in secondaryValues" class="col button-holder" :key="val.id">
            <button type="button" class="btn" :class="{ 'btn-success': secondarySubjects.includes(val.id), 'btn-outline-dark': !secondarySubjects.includes(val.id)}" @click="addSecondarySubject(val.id)">{{val.name}}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row subject-select-footer">
      <div>
        <div class="btn btn-success" @click="save" :disabled="!primarySubject">Next</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import PortalFetchJson from '@/js/PortalFetchJson'

export default {
  name: 'SubjectSelection',
  emits: ['savedSubjects'],
  components: {
  },
  data () {
    return {
      values: [],
      isPrepped: false,
      primarySubject: null,
      secondarySubjects: []
    }
  },
  methods: {
    async getReady () {
      var subjectsResponse = await PortalFetchJson('subjects')
      this.values = subjectsResponse.subjects
      var preSelected = this.info.subject_ids
      if (preSelected) {
        this.primarySubject = preSelected[0] ? preSelected[0] : null
        preSelected.shift()
        this.secondarySubjects = preSelected
      }
      this.isPrepped = true
    },
    setPrimarySubject (value) {
      if (this.primarySubject === value) {
        this.primarySubject = null
        this.secondarySubjects = []
      } else if (this.primarySubject === null) {
        this.primarySubject = value
      }
    },
    addSecondarySubject (value) {
      var curIndex = this.secondarySubjects.indexOf(value)
      if (curIndex > -1) {
        this.secondarySubjects.splice(curIndex, 1)
      } else {
        if (this.secondarySubjects.length < 2) {
          this.secondarySubjects.push(value)
        }
      }
    },
    setSubjects (value) {
      var fieldChange = { field: 'subject_ids', value }
      this.setField(fieldChange)
    },
    async save () {
      this.setSubjects([this.primarySubject, ...this.secondarySubjects])
      await this.saveData()
      if (Object.keys(this.infoErrors).length === 0) {
        this.$emit('savedSubjects')
      }
    },
    ...mapMutations({
      setField: 'consumer/additionalInfo/setField'
    }),
    ...mapActions({
      saveData: 'consumer/saveAdditionalData'
    })
  },
  computed: {
    secondaryValues () {
      return this.values.filter((val) => val.id !== this.primarySubject)
    },
    ...mapGetters({
      info: 'consumer/additionalInfo/getInfo',
      infoErrors: 'consumer/additionalInfo/getErrors'
    }),
    ...mapState({
      questions: state => state.consumer.additionalInfo.questions
    })
  },
  mounted () {
    this.getReady()
  },
  watch: {
  }
}
</script>

<style scoped>
.subject-select {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding: 0 calc(var(--bs-gutter-x) / 2);
}
.subject-select > .row {
  border-bottom: 1px solid lightgray;
  padding-top: 10px;
  padding-bottom: 15px;
}
.row.subject-select-footer {
  border: none;
  text-align: center;
}
.subject-select-footer .btn {
  padding: 10px 20px;
}
.button-holder {
  margin-bottom: 10px;
}
.button-holder button {
  width: 100%;
  font-size: 12px;
  padding: 5px 10px;
}
.edit-icon svg {
  height: 2em;
}
.subject-select-header {
  font-size: 18px;
  background-color: #f5f5f5;
}
.subject-select-header .text-center {
  padding-top: 10px;
}
</style>
